import React from 'react';
import { useSelector } from 'react-redux';
import Banner from '../components/Banner/banner';
import Nav from '../components/Nav/nav';
import Cards2 from '../components/Cards/Cards2';
import Footer from '../components/Footer/Footer';
import Nav2 from '../components/Nav2/Nav2';



const LandingPage = () => {

    const { isLoggedIn } = useSelector(state => state.auth);
    console.log(isLoggedIn, 'bitch');

    return (
        <div>
            {isLoggedIn ? <Nav2 /> : <Nav />}
            {/* <Nav /> */}
            <Banner />
            <Cards2 />
            <Footer />
        </div>
    )
}

export default LandingPage;